"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function JetLabel(_a) {
    var value = _a.value, htmlFor = _a.htmlFor, children = _a.children;
    return (react_1.default.createElement("label", { className: "block font-medium text-sm text-gray-700", htmlFor: htmlFor }, value || children));
}
exports.default = JetLabel;
